import { aggByMetricByUniv } from '../universes';
/** Get all the universes available for a plot & also return the preferred one */
const usePlotUniverses = (plot) => {
    const firstUniverseEntryWithKeyAsString = Object.entries(aggByMetricByUniv).find(([, aggsByMetrics]) => {
        return Object.keys(aggsByMetrics).some((metric) => plot?.availableMeasures.includes(metric));
    });
    const universe = firstUniverseEntryWithKeyAsString
        ? /** NEVER FORGET to parse the string (since ist is from an object key) that should be a number */
            parseInt(firstUniverseEntryWithKeyAsString[0], 10)
        : undefined;
    return { universe };
};
export default usePlotUniverses;
